import React from 'react';

import './style.scoped.scss';
import { FaRegWindowClose } from 'react-icons/fa';

const CloseButton = ({
  handleClose,
  title,
  white,
}) => {
  return (
    <FaRegWindowClose
      onClick={handleClose}
      className={`close-icon${white ? ' white' : ''}`}
      title={title ? title : 'Close'}
    />
  );
};

export default CloseButton;
